// SET Auth Types
export const SET_NEW_SIGNUP = 'iron/auth/SET_NEW_SIGNUP';
export const SET_AUTH_FORM_TYPE = 'iron/auth/SET_AUTH_FORM_TYPE';
export const SET_AUTH_PROPERTY = 'iron/auth/SET_AUTH_PROPERTY';
export const SET_AUTH0_USER = 'iron/auth0/SET_AUTH0_USER';

// COOKIE Auth Types
export const AUTH_FROM_COOKIES_SUCCESS = 'iron/auth/AUTH_FROM_COOKIES_SUCCESS';
export const AUTH_FROM_COOKIES_ERROR = 'iron/auth/AUTH_FROM_COOKIES_ERROR';

// GETME Auth Types
export const GETME_REQUEST = 'iron/auth/GETME_REQUEST';
export const GETME_SUCCESS = 'iron/auth/GETME_SUCCESS';
export const GETME_FAILURE = 'iron/auth/GETME_FAILURE';

// LOGIN/LOGOUT Auth Types
export const LOG_OUT_TRY = 'iron/auth/LOG_OUT_REQUEST';
export const AUTHO_LOGIN = 'iron/auth0/AUTHO_LOGIN';

// HANDLE Auth Types
export const HANDLE_AUTHENTICATION = 'iron/auth0/HANDLE_AUTHENTICATION';
export const HANDLE_AUTHENTICATION_SUCCESS =
  'iron/auth0/HANDLE_AUTHENTICATION_SUCCESS';

export const AUTH0_PASSWORD_RESET = 'iron/auth0/AUTH0_PASSWORD_RESET';
